export default __webpack_public_path__ + "static/smiling-woman-laptop-colorful-frame@2x-e660e6cbbdc84016e2a7d766919fc619.webp";